import React from "react";
const CustomErrorMessage = (props) => {
    return <div className={"text-[#e58282] text-[14px] text-right"}>{props.children}</div>;
};
export default CustomErrorMessage;